import { vent } from '../../../../../store/constants';

export const closeTimeTrackerDialog = () => {
    return () => {
        vent.trigger(vent['modal:closed']);
    }
}
